module.exports = __webpack_public_path__ + "img/default-profile.b4e33095.svg";